import { type Schema } from 'yup';
import { type LiveContextTransform } from './LiveTypes.ts';
import {
  LIVE_CONTEXT_TRANSFORM_KEY,
  markLiveTransformApplied,
} from './live.ts';

/**
 * Invoca la `LiveContextTransform` e marca il risultato come live.
 * Se lo schema non ne ha una registrata, ritorna il context base inalterato.
 *
 * Effetto collaterale: aggiunge il marker `HAS_LIVE_TRANSFORM_APPLIED`
 * all'oggetto ritornato dalla transform. La transform DEVE ritornare un nuovo
 * oggetto (no mutazione dell'input), altrimenti il marker leakerebbe sul
 * context originale del chiamante.
 */
export function applyLiveContextTransform(
  schema: Schema,
  values: any,
  context: any,
): any {
  const baseContext = context ?? {};
  const transform = schema.meta()?.[LIVE_CONTEXT_TRANSFORM_KEY] as
    | LiveContextTransform
    | undefined;
  if (!transform) return baseContext;

  const liveContext = transform(schema, values, baseContext);
  markLiveTransformApplied(liveContext);
  return liveContext;
}
